import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";

import mergeStyles from "../../util/mergeStyles";

const Base = styled.div<{ isLoading: boolean }>`
  background-color: ${p =>
    p.isLoading ? select.color(["grey", 0]) : select.color(["primary", 0], p)};
  border-radius: 50%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  src: string;
  size: number;
  children?: React.ReactNode;
  onClick?: () => void;
  isLoading?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

function Avatar(
  { style, className, src, size, children, onClick, isLoading, ...rest }: Props,
  ref: any
) {
  return (
    <Base
      ref={ref}
      style={mergeStyles(style, {
        width: size,
        height: size
      })}
      className={className}
      onClick={onClick}
      isLoading={isLoading!}
      {...rest}
    >
      {!isLoading && (
        <>
          <Image src={src} />
          {children}
        </>
      )}
    </Base>
  );
}

export default React.forwardRef(Avatar);
